import { useState } from 'react';
import type { LeadFilters } from '../components/LeadsSearchFilters';
import { leadService } from '../services/domain/leadService';

export type ExportColumn = {
    key: string;
    label: string;
    enabled: boolean;
};

export interface ExportFilters {
    dateFrom:   string;   // YYYY-MM-DD
    dateTo:     string;   // YYYY-MM-DD
    statusId:   string;
    sourceId:   string;
    agentId:    string;
    programaId: string;
}

export const DEFAULT_EXPORT_FILTERS: ExportFilters = {
    dateFrom:   '',
    dateTo:     '',
    statusId:   '',
    sourceId:   '',
    agentId:    '',
    programaId: '',
};

export const DEFAULT_EXPORT_COLUMNS: ExportColumn[] = [
    { key: 'nombre',        label: 'Nombre',                enabled: true  },
    { key: 'apellido',      label: 'Apellido',              enabled: true  },
    { key: 'email',         label: 'Correo',                enabled: true  },
    { key: 'telefono',      label: 'Teléfono',              enabled: true  },
    { key: 'status_name',   label: 'Estado',                enabled: true  },
    { key: 'source_name',   label: 'Fuente',                enabled: true  },
    { key: 'agent_name',    label: 'Agente',                enabled: false },
    { key: 'process_stage', label: 'Etapa',                 enabled: false },
    { key: 'programa',      label: 'Programa de interés',   enabled: false },
    { key: 'ciudad',        label: 'Ciudad',                enabled: false },
    { key: 'descripcion',   label: 'Descripción',           enabled: false },
    { key: 'created_at',    label: 'Fecha de creación',     enabled: false },
    { key: 'updated_at',    label: 'Última actualización',  enabled: false },
];

export interface ExportOptions {
    baseFilters:   LeadFilters;
    exportFilters: ExportFilters;
    columns:       ExportColumn[];
}

export function useExportLeads() {
    const [exporting,    setExporting]    = useState(false);
    const [exportError,  setExportError]  = useState<string | null>(null);

    const exportToExcel = async ({ baseFilters, exportFilters, columns }: ExportOptions) => {
        setExporting(true);
        setExportError(null);

        try {
            // Columnas habilitadas como CSV
            const columnsCSV = columns
                .filter((c) => c.enabled)
                .map((c) => c.key)
                .join(',');

            // Los filtros del export tienen prioridad sobre los del listado
            const { blob, filename } = await leadService.exportLeads({
                searchTerm:     baseFilters.searchTerm     || undefined,
                user_id:        exportFilters.agentId      || baseFilters.agentId   || undefined,
                lead_source_id: exportFilters.sourceId     || baseFilters.sourceId  || undefined,
                lead_status_id: exportFilters.statusId     || baseFilters.statusId  || undefined,
                programa_id:    exportFilters.programaId   || undefined,
                date_from:      exportFilters.dateFrom     || undefined,
                date_to:        exportFilters.dateTo       || undefined,
                columns:        columnsCSV                 || undefined,
            });

            // Disparar descarga en el navegador
            leadService.downloadBlob(blob, filename);

        } catch (err) {
            setExportError(err instanceof Error ? err.message : 'Error desconocido');
        } finally {
            setExporting(false);
        }
    };

    return { exportToExcel, exporting, exportError };
}